import { createSlice } from "@reduxjs/toolkit";


// Then, handle actions in your reducers:
const popupSlice = createSlice({
  name: "categories",
  initialState: {
    id: null,
    visibility: false,
    logout: false
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    showLogoutPopup(state, action) {
      return { logout: true };
    },
    hidePopup(state, action) {
      return { ...state, visibility: false, logout: false, changeLanguage: false, };
    },
    showPopup(state, action) {
      return { id: action.payload.id, visibility: true };
    },
    showLanguagePopup(state, action) {
      return { id: action.payload.id, changeLanguage: true };
    },
  },
});

export const { hidePopup, showPopup, showLogoutPopup, showLanguagePopup } = popupSlice.actions;
export default popupSlice.reducer;
